import React from 'react';
import { useAppSelector } from '../app/hooks';
import TouchableOpacity from './TouchableOpacity';
import { MdClose } from 'react-icons/md';
import getThemeLookup from '../selectors/getThemeLookup';
// @ts-ignore
import { UilAngleLeftB } from '@iconscout/react-unicons';

const ModalBackButton = ({
  onClick,
  showCloseButton = false,
}: {
  onClick: () => void;
  showCloseButton?: boolean;
}) => {
  const p = useAppSelector(getThemeLookup);
  const Icon = showCloseButton ? MdClose : UilAngleLeftB;
  return (
    <TouchableOpacity onClick={onClick}>
      <Icon
        size={p('reviewOrderBackIcon', ['fontSize']).fontSize || 36}
        color={p('reviewOrderBackIcon', ['color']).color}
      />
    </TouchableOpacity>
  );
};

export default ModalBackButton;
